import { AnchorHTMLAttributes } from 'react'

interface DownloadButton extends AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string
  name: string
}

export const DownloadAnchor: React.FC<DownloadButton> = ({
  url,
  name,
  children,
  ...rest
}) => {
  return (
    <a href={url} download={name} target="_blank" rel="noreferrer" {...rest}>
      {children}
    </a>
  )
}
